module.exports = __webpack_public_path__ + "static/media/dsc_2771_compressed.b0be10ac.jpg";